// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome-notifications/dist/styles/style.css
// module id = 244
// module chunks = 1